import { render, staticRenderFns } from "./crear-cotizacion.vue?vue&type=template&id=bb81f8ea&"
import script from "./crear-cotizacion.vue?vue&type=script&lang=js&"
export * from "./crear-cotizacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports